module.exports = __webpack_public_path__ + "img/step-5.f3ca1e90.jpg";